import { assessmentTemplate as ad8, assessmentScoring as ad8Scoring } from "./ad8";
import {
  assessmentTemplate as ar1001Prescreen,
  assessmentScoring as ar1001PrescreenScoring,
} from "./ar1001Prescreen";
import {
  assessmentTemplate as careFirstWeight,
  assessmentScoring as careFirstWeightScoring,
} from "./careFirstWeight";
import {
  assessmentTemplate as clinicalDementiaRating,
  assessmentScoring as clinicalDementiaRatingScoring,
} from "./clinicalDementiaRating";
import {
  assessmentTemplate as dementiaSeverityRatingScale,
  assessmentScoring as dementiaSeverityRatingScaleScoring,
} from "./dementiaSeverityRatingScale";
import {
  assessmentTemplate as eos5Pillars,
  assessmentScoring as eos5PillarsScoring,
} from "./eos5Pillars";
import {
  assessmentTemplate as eosBusinessInformation,
  assessmentScoring as eosBusinessInformationScoring,
} from "./eosBusinessInformation";
import {
  assessmentTemplate as eosOnboarding,
  assessmentScoring as eosOnboardingScoring,
} from "./eosOnboarding";
import {
  assessmentTemplate as epworthSleepinessScale,
  assessmentScoring as epworthSleepinessScaleScoring,
} from "./epworthSleepinessScale";
import { assessmentTemplate as gad7, assessmentScoring as gad7Scoring } from "./gad7";
import {
  assessmentTemplate as hyperOnboard,
  assessmentScoring as hyperOnboardScoring,
} from "./hyperOnboard";
import {
  assessmentTemplate as independentFunction,
  assessmentScoring as independentFunctionScoring,
} from "./independentFunction";
import { assessmentTemplate as msqol, assessmentScoring as msqolScoring } from "./msqol";
import {
  assessmentTemplate as omniHealthHistory,
  assessmentScoring as omniHealthHistoryScoring,
} from "./omniHealthHistory";
import {
  assessmentTemplate as omniHealthHistoryDemo,
  assessmentScoring as omniHealthHistoryDemoScoring,
} from "./omniHealthHistoryDemo";
import {
  assessmentTemplate as omniMSOnboard,
  assessmentScoring as omniMSOnboardScoring,
} from "./omniMSOnboard";
import {
  assessmentTemplate as omniMedicationReminderDemo,
  assessmentScoring as omniMedicationReminderDemoScoring,
} from "./omniMedicationReminderDemo";
import {
  assessmentTemplate as pcrHairLoss,
  assessmentScoring as pcrHairLossScoring,
} from "./pcrHairLoss";
import { assessmentTemplate as phq8, assessmentScoring as phq8Scoring } from "./phq8";
import { assessmentTemplate as phq9, assessmentScoring as phq9Scoring } from "./phq9";
import {
  assessmentTemplate as singleLegStance,
  assessmentScoring as singleLegStanceScoring,
} from "./singleLegStance";

// import {
//   assessmentTemplate as uiControlTest,
//   assessmentScoring as uiControlTestScoring,
// } from "./uiControlTest";

export const assessmentTemplates = [].concat(
  ar1001Prescreen,
  independentFunction,
  ad8,
  careFirstWeight,
  clinicalDementiaRating,
  dementiaSeverityRatingScale,
  epworthSleepinessScale,
  gad7,
  msqol,
  omniHealthHistory,
  phq8,
  phq9,
  singleLegStance,
  pcrHairLoss,
  eosBusinessInformation,
  eos5Pillars,
  eosOnboarding,
  omniHealthHistoryDemo,
  omniMSOnboard,
  omniMedicationReminderDemo,
  hyperOnboard
  // uiControlTest
);

export const assessmentScoring = [].concat(
  ar1001PrescreenScoring,
  independentFunctionScoring,
  ad8Scoring,
  careFirstWeightScoring,
  clinicalDementiaRatingScoring,
  dementiaSeverityRatingScaleScoring,
  epworthSleepinessScaleScoring,
  gad7Scoring,
  msqolScoring,
  omniHealthHistoryScoring,
  phq8Scoring,
  phq9Scoring,
  singleLegStanceScoring,
  pcrHairLossScoring,
  eosBusinessInformationScoring,
  eos5PillarsScoring,
  eosOnboardingScoring,
  omniHealthHistoryDemoScoring,
  omniMSOnboardScoring,
  omniMedicationReminderDemoScoring,
  hyperOnboardScoring
  // uiControlTestScoring
);
